export default "/etc.clientlibs/des/cart-checkout/clientlibs/des-cart-checkout/resources/2014e4a0c7dd04d939d117b4329e7468.png";